import { render } from "./table-row-info.vue?vue&type=template&id=a9700988"
import script from "./table-row-info.vue?vue&type=script&lang=js"
export * from "./table-row-info.vue?vue&type=script&lang=js"

import "./table-row-info.vue?vue&type=style&index=0&id=a9700988&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__